import { getLocalizedPath } from './routing';

export function getOgImageForRoute(language: string, pathname: string): string {
  // Normalize path (remove trailing slash, query params)
  const normalizedPath = pathname.split('?')[0].replace(/\/$/, '') || '/';
  
  // Convert any localized path to Slovak (canonical) path for mapping.
  // getLocalizedPath returns trailing-slash paths ('/cennik/'), but the maps
  // below use non-trailing-slash keys — normalize before lookup.
  const canonicalPath = getLocalizedPath(normalizedPath, 'sk').replace(/\/$/, '') || '/';
  
  // Check if this is a module detail page (e.g., /moduly/projektove-riadenie)
  if (canonicalPath.startsWith('/moduly/')) {
    // Extract module slug from the path
    const moduleSlug = canonicalPath.split('/').pop();
    // Only modules with a generated OG image (public/og/<lang>/<slug>.jpg)
    // may use a page-specific image — others must fall back to the generic one.
    const modulesWithOgImage = [
      'bankovnictvo',
      'bezpecnost-kvalita',
      'cenove-ponuky',
      'crm-system-prehlad-zakaznikov',
      'fakturacny-modul',
      'firemne-vydavky',
      'kalendar-planovanie',
      'kalkulacie',
      'kontrola-nakladov',
      'majetok-firmy',
      'mobilna-aplikacia',
      'online-fakturacia',
      'projektove-riadenie',
      'reporting-analytika',
      'riadenie-timov',
      'sklad-materialy',
      'sledovanie-materialov',
      'spracovanie-dokladov',
      'sprava-dokumentov',
      'sprava-techniky',
      'stavebny-dennik',
      'subkontraktori',
      'vozidla-trasy',
      'vykaz-prace-a-evidencia-dochadzky',
    ];
    if (moduleSlug && modulesWithOgImage.includes(moduleSlug)) {
      const supportedLanguages = ['sk', 'cs', 'da', 'en'];
      const lang = supportedLanguages.includes(language) ? language : 'en';
      // Use the module slug directly as the OG image filename
      return `/og/${lang}/${moduleSlug}.jpg`;
    }
  }
  
  // Map main pages that have generated OG images
  // These are now all in Slovak (canonical) format
  const routeToSlugMap: Record<string, string> = {
    '/': 'homepage',
    '/cennik': 'cennik',
    '/moduly': 'moduly',
    '/o-nas': 'o-nas',
    '/kontakt': 'kontakt',
  };

  const slug = routeToSlugMap[canonicalPath];

  // If this route doesn't have a page-specific image, return fallback
  if (!slug) {
    return '/og-image.jpg';
  }

  const supportedLanguages = ['sk', 'cs', 'da', 'en'];
  const lang = supportedLanguages.includes(language) ? language : 'en';

  return `/og/${lang}/${slug}.jpg`;
}
